export function isSecretProjectPath(pathname: string): boolean {
  return (
    pathname === '/secretProject' ||
    pathname === '/searchsecretProject' ||
    pathname.startsWith('/secretProject/')
  );
}
